var _excluded = ["onClick", "children", "sortDirection", "textAlign", "initialSortDirection"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef, VisuallyHidden } from '@chakra-ui/react';
import { useCallback, useMemo } from 'react';
import { Group } from '../../../containers';
import { Icon } from '../../../foundations/Icon';
import { useBoolean } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Text } from '../../dataDisplay';
import { _TableHeaderCell } from '../_TableHeaderCell';
import { Box } from '../Box';
/**
 * @private Please use `TableHeaderSortableCellProps` from `@melio/penny`.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * @private This is for internal use only. Please use `Table.HeaderSortableCell` from `@melio/penny`.
 */
export var _TableHeaderSortableCell = forwardRef((_ref, ref) => {
  var _ref2;

  var {
    onClick,
    children,
    sortDirection,
    textAlign,
    initialSortDirection = 'desc'
  } = _ref,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var [isHovered, setIsHovered] = useBoolean(false);
  var isSorting = !!sortDirection;
  var style = useMultiStyleConfig('TableHeaderSortableCell', {
    isSorting,
    textAlign,
    isClickable: !!onClick
  });
  var sortDirections = useMemo(() => initialSortDirection === 'desc' ? ['none', 'desc', 'asc'] : ['none', 'asc', 'desc'], [initialSortDirection]);
  var sortDirectionIcons = {
    none: undefined,
    desc: 'arrow-down',
    asc: 'arrow-up'
  }; // eslint-disable-next-line react-hooks/exhaustive-deps

  var sortDirIndex = useMemo(() => sortDirections.indexOf(sortDirection !== null && sortDirection !== void 0 ? sortDirection : 'none'), [sortDirection]);
  var nextSortDirection = useMemo(() => sortDirIndex === sortDirections.length - 1 ? sortDirections[0] : sortDirections[sortDirIndex + 1], [sortDirIndex, sortDirections]);
  var sortIcon = (_ref2 = sortDirection && sortDirectionIcons[sortDirection]) !== null && _ref2 !== void 0 ? _ref2 : nextSortDirection && sortDirectionIcons[nextSortDirection];
  var stateBySortDirection = {
    asc: 'sorted ascending',
    desc: 'sorted descending'
  };
  var sortState = sortDirection ? stateBySortDirection[sortDirection] : undefined;
  var handleSort = useCallback(() => {
    onClick === null || onClick === void 0 ? void 0 : onClick(nextSortDirection === 'none' ? undefined : nextSortDirection);
  }, [onClick, nextSortDirection]);
  return /*#__PURE__*/_jsx(_TableHeaderCell, _objectSpread(_objectSpread({
    "data-testid": "header-sortable-cell",
    "data-component": "_TableHeaderSortableCell",
    onClick: onClick && handleSort,
    ref: ref,
    onMouseOver: setIsHovered.on,
    onMouseOut: setIsHovered.off,
    "data-hover": onClick && isHovered || undefined,
    "data-selected": isSorting,
    textAlign: textAlign,
    as: "button"
  }, restProps), {}, {
    children: /*#__PURE__*/_jsxs(Group, {
      spacing: "xs",
      children: [typeof children === 'string' ? /*#__PURE__*/_jsx(Text, {
        textStyle: "inline",
        color: "inherit",
        shouldSupportEllipsis: true,
        children: children
      }) : children, sortState && /*#__PURE__*/_jsx(VisuallyHidden, {
        children: sortState
      }), /*#__PURE__*/_jsx(Box, {
        __css: style['icon'],
        "data-hover": onClick && isHovered || undefined,
        "data-testid": "header-sortable-cell-icon-".concat(sortDirection),
        children: /*#__PURE__*/_jsx(Icon, {
          type: sortIcon,
          color: "inherit",
          size: "small",
          "aria-hidden": true
        })
      })]
    })
  }));
});
_TableHeaderSortableCell.displayName = '_TableHeaderSortableCell';
//# sourceMappingURL=_TableHeaderSortableCell.js.map